'use client';
import { createStyles } from '@s7/styles';
import { getStackStyles } from './utils/getStackStyles/getStackStyles.js';
import { getSizeStyles } from './utils/getSizeStyles/getSizeStyles.js';
import { getAnimationContextStyles } from './utils/getAnimationContextStyles/getAnimationContextStyles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function(theme, params, variations) {
    var _theme_fn = theme.fn, primaryShade = _theme_fn.primaryShade, themeColor = _theme_fn.themeColor;
    var color = primaryShade(themeColor(params.color));
    return {
        stack: getStackStyles(theme, params),
        root: _extends({
            display: "block",
            position: "relative",
            WebkitTransform: "translateZ(0)"
        }, getSizeStyles(theme, params, variations)),
        visible: _extends({
            "&::before": {
                inset: 0,
                position: "absolute",
                content: '""',
                zIndex: 10,
                background: color
            }
        }, getAnimationContextStyles(theme, params))
    };
});

export { useStyles as default };
